import {BannerTypesEnum} from '../../../../../libs/shared/core/src/store/banners/commonBannerState';
import {SuccessBannerTypesEnum} from '../../../../../libs/shared/core/src/store/banners/commonBannerTypes';
import {
  BannerState,
  MacrosBannerState,
  MacrosSuccessBannerState,
} from '../../../../store/panels/app/banners/bannersState';

export function isMacrosBanner(banner: BannerState): banner is MacrosBannerState {
  return isMacrosSuccessBanner(banner);
}

export function isMacrosSuccessBanner(banner: BannerState): banner is MacrosSuccessBannerState {
  return banner.type === BannerTypesEnum.SUCCESS && banner.successType === SuccessBannerTypesEnum.MACRO;
}
